<template>
    <div class="file-preview-grid my-2">
        <div
            v-for="(item, index) in normalizedItems"
            :key="item.id || index"
            class="file-preview-grid__item"
        >
            <a
                :href="item.url"
                target="_blank"
                rel="noopener"
                class="file-preview-grid__card"
                :title="item.label"
            >
                <div class="file-preview-grid__preview">
                    <img
                        v-if="item.isImage"
                        :src="item.thumbUrl || item.url"
                        :alt="item.label"
                        class="file-preview-grid__thumb"
                    >
                    <div v-else class="file-preview-grid__file-icon-wrap">
                        <span class="file-preview-grid__file-icon">📄</span>
                    </div>
                </div>

                <div class="file-preview-grid__label">
                    {{ item.label }}
                </div>
            </a>
        </div>

        <p v-if="!normalizedItems.length" class="file-preview-grid__empty">
            No files
        </p>
    </div>
</template>

<script>
export default {
    name: 'FilePreviewGrid',
    props: {
        items: {
            type: [Array, Object, String, null],
            default: () => [],
        },
        type: {
            type: String,
            default: 'media',
        },
    },
    computed: {
        normalizedItems() {
            let items = this.items;
            if (!items) {
                return [];
            }

            if (typeof items === 'string') {
                items = [items];
            }

            if (!Array.isArray(items)) {
                items = [items];
            }

            return items
                .map((raw, index) => this.normalizeItem(raw, index))
                .filter(item => !!item && !!item.url);
        },
    },
    methods: {
        normalizeItem(raw, index) {
            if (this.type === 'media') {

                if (!raw || typeof raw !== 'object') {
                    return null;
                }

                const mime = raw.mime_type || raw.mimeType || '';
                const url = raw.original_url || raw.url || raw.full_url || null;
                const thumb = raw.preview_url || raw.thumb_url || null;

                if (!url) {
                    return null;
                }

                const isImage = mime.startsWith('image/') || this.isImageByExtension(url);

                const label = raw.file_name || raw.name || this.extractFileName(url);

                return {
                    id: raw.id || index,
                    url,
                    thumbUrl: thumb,
                    label,
                    isImage,
                };
            }

            if (this.type === 'links') {
                let url = null;
                let label = null;

                if (typeof raw === 'string') {
                    url = raw;
                    label = this.extractFileName(url);
                } else if (raw && typeof raw === 'object') {
                    url = raw.url || raw.href || null;
                    label = raw.label || raw.name || this.extractFileName(url);
                }

                if (!url) {
                    return null;
                }

                const isImage = this.isImageByExtension(url);

                return {
                    id: raw.id || index,
                    url,
                    thumbUrl: null,
                    label,
                    isImage,
                };
            }

            return null;
        },

        isImageByExtension(url) {
            if (!url) return false;
            const lower = url.split('?')[0].toLowerCase();
            return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/.test(lower);
        },

        extractFileName(url) {
            if (!url) return '';
            try {
                const path = url.split('?')[0];
                const parts = path.split('/');
                return parts[parts.length - 1] || url;
            } catch (e) {
                return url;
            }
        },
    },
};
</script>

<style scoped>
.file-preview-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-start;
}

.file-preview-grid__item {
    width: 120px;
}

.file-preview-grid__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: inherit;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    transition: transform .12s ease-out, box-shadow .12s ease-out;
}

.file-preview-grid__card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
}

.file-preview-grid__preview {
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #f8f8f8;
}

.file-preview-grid__thumb {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.file-preview-grid__file-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
}

.file-preview-grid__label {
    padding: 6px 8px 8px;
    font-size: 11px;
    text-align: center;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-preview-grid__empty {
    font-size: 12px;
    color: #999;
}
</style>
